import { OverlayModule } from '@angular/cdk/overlay';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../auth/services/auth.service';

@Component({
    selector: 'app-user-menu-button',
    imports: [
        OverlayModule,
        RouterLink,
        RouterLinkActive,
        MatButtonModule,
        MatIconModule,
        MatListModule,
        MatDividerModule
    ],
    templateUrl: './user-menu-button.component.html',
    styleUrl: './user-menu-button.component.scss'
})
export class UserMenuButtonComponent {

  private authService = inject(AuthService);

  /** Logged in user */
  public user$ = this.authService.user$;

  isOpen = false;

  constructor() {}
}
